<template>
  <v-btn
    color="#000"
    @click="clickAction"
    block
    class="font-weight-bold normal_simple_button"
    elevation="0"
    height="44px"
  >
    <p>{{ buttonTitle }}</p>
  </v-btn>
</template>

<script>
export default {
  name: "NormalSimpleBlackButton",
  data: () => ({}),
  methods: {
    clickAction() {
      this.$emit("clickAction");
    }
  },
  components: {},
  props: ["buttonTitle"]
};
</script>

<style scoped>
.normal_simple_button {
  border-radius: 22px;
  border: 1px solid #ffffff;
}
p {
  margin: 0;
  color: #fff;
  font-weight: bold;
}
</style>
